function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.57071 1.24919L17.2121 8.89065C17.5807 9.25918 17.5807 9.85668 17.2121 10.2252L16.3209 11.1164C15.953 11.4843 15.3567 11.485 14.9879 11.118L8.90343 5.06202L2.81897 11.118C2.4502 11.485 1.85392 11.4843 1.48601 11.1164L0.594764 10.2252C0.226225 9.85664 0.226225 9.25914 0.594764 8.89065L8.23618 1.24923C8.60468 0.880692 9.20217 0.880692 9.57071 1.24919Z",
  fill: "#274160"
});

var SvgVector = function SvgVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Vector.ef10f193.svg";
export { ForwardRef as ReactComponent };